import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

import { Brand } from "@/components/brand";
import { Button } from "@/components/ui/button";

/**
 * Marketing-surface header. Lives above the homepage and any future public
 * pages. The dashboard layout has its own sidebar nav and does not render
 * this header.
 */
export function SiteHeader() {
  return (
    <header className="sticky top-0 z-30 border-b border-border/50 bg-background/75 backdrop-blur-md">
      <div className="container flex h-16 items-center justify-between gap-6">
        <Brand />
        <nav className="hidden items-center gap-7 text-sm text-muted-foreground md:flex">
          <a href="#features" className="transition-colors hover:text-foreground">
            Features
          </a>
          <a href="#workspace" className="transition-colors hover:text-foreground">
            Workspace
          </a>
          <a
            href="https://github.com/knode-os/knode-os"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 transition-colors hover:text-foreground"
          >
            GitHub <ArrowUpRight className="h-3.5 w-3.5" />
          </a>
        </nav>
        <div className="flex items-center gap-2">
          <Button asChild size="sm" className="rounded-full px-4 shadow-sm">
            <Link to="/login">Sign in</Link>
          </Button>
        </div>
      </div>
    </header>
  );
}
